<template>
  <main class="main">
    <div class="anim-wrap" :class="{ loading: loading }">
      <div class="container">
        <div class="row">
          <div class="col-12 mb-5">
            <h1>Profile</h1>
            <h4 class="color-grey">Update details</h4>
          </div>
        </div>
        <b-alert show v-if="!getUserData.updatedDetails"
          >Welcome to Traistack Plus. Please start by setting a new
          password.</b-alert
        >
        <div class="row">
          <div class="col-md-12">
            <div
              class="panel content-panel content-panel-large intro-panel pad-medium"
            >
              <form action="javascript:void(0);">
                <div class="col-md-8">
                  <h3>Update details</h3>

                  <label>First name</label>
                  <input
                    ref="firstname"
                    type="text"
                    v-model="firstName"
                    class="form-control"
                    placeholder="First name"
                  />

                  <label>Last name</label>
                  <input
                    type="text"
                    v-model="lastName"
                    class="form-control"
                    placeholder="Last name"
                  />
                  <h3>Change password</h3>
                  <b-alert
                    show
                    variant="warning"
                    v-if="!getUserData.updatedDetails"
                    >Please update update your password.</b-alert
                  >
                  <div v-if="getUserData.updatedDetails">
                    <label>Current password</label>
                    <input
                      style="margin-bottom: 10px"
                      type="password"
                      v-model="currentPassword"
                      class="form-control"
                      ref="currentPassword"
                      placeholder="Current password"
                    />
                  </div>
                  <label>New password</label>
                  <input
                    style="margin-bottom: 10px"
                    type="password"
                    v-model="newPassword"
                    class="form-control"
                    ref="newPassword"
                    placeholder="New password"
                  />
                  <label>Re-type new password</label>
                  <input
                    type="password"
                    v-model="newPasswordRetype"
                    class="form-control"
                    ref="newPasswordRetype"
                    placeholder="Re-type new password"
                  />
                </div>

                <div class="row">
                  <div class="col-12 py-4">
                    <hr />
                  </div>
                  <div class="col-md-12 text-right">
                    <router-link to="/" class="btn btn-link"
                      >Cancel</router-link
                    >
                    <button
                      type="submit"
                      @click="updateDetails"
                      class="btn btn-primary btn-loader"
                      :class="{ active: loading, success: success }"
                    >
                      <span>Save and continue</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
// FireBase
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/functions";

import { mapState } from "vuex";

export default {
  name: "dashboard",
  components: {},
  data() {
    return {
      firstName: "",
      lastName: "",
      currentPassword: null,
      newPassword: null,
      newPasswordRetype: null,
      password: null,
      loading: false,
      success: false,
    };
  },
  mounted() {
    if (this.getUserData.firstName) {
      this.firstName = this.getUserData.firstName;
    }

    if (this.getUserData.lastName) {
      this.lastName = this.getUserData.lastName;
    }
  },
  computed: {
    ...mapState(["user"]),
    ...mapState(["userData"]),
    getUser() {
      return this.user ? this.user : "";
    },
    getUserData() {
      return this.userData ? this.userData : "";
    },
  },
  methods: {
    resetErrorState() {
      this.loading = false;
      this.success = false;
      this.error = false;
    },

    updateDetails() {
      if (!this.newPassword || !this.newPasswordRetype) {
        this.$toast.open({
          message: "You have to change your password",
          type: "error",
        });
        return false;
      }
      if (this.newPassword && this.newPasswordRetype) {
        this.updatePassword();
      } else {
        this.updateAccount();
      }
    },

    updatePassword() {
      if (this.newPassword !== this.newPasswordRetype) {
        this.$errorMessage("Passwords do not match");
        return false;
      }
      if (this.loading) {
        return false;
      }

      this.loading = true;
      var user = firebase.auth().currentUser;

      if (this.getUserData.updateDetails) {
        var credential = firebase.auth.EmailAuthProvider.credential(
          this.getUser.email,
          this.currentPassword
        );
        this.user
          .reauthenticateWithCredential(credential)
          .then(() => {
            user
              .updatePassword(this.newPassword)
              .then(() => {
                this.newPassword = null;
                this.newPasswordRetype = null;
                this.currentPassword = null;
                this.loading = false;
                this.$successMessage("Password updated succesfully.");
                this.updateAccount();
              })
              .catch((error) => {
                this.loading = false;
                this.$errorMessage(error.message);
              });
          })
          .catch((error) => {
            this.loading = false;
            this.$errorMessage(error.message);
          });
      } else {
        user
          .updatePassword(this.newPassword)
          .then(() => {
            this.newPassword = null;
            this.newPasswordRetype = null;
            this.currentPassword = null;
            this.loading = false;
            this.$successMessage("Password updated succesfully.");
            this.updateAccount();
          })
          .catch((error) => {
            this.loading = false;
            this.$errorMessage(error.message);
          });
      }
    },

    updateAccount: function() {
      this.loading = true;
      let saveProfile = firebase.functions().httpsCallable("saveProfile");

      saveProfile({
        firstName: this.firstName,
        lastName: this.lastName,
      })
        .then(() => {
          this.loading = false;
          this.$router.push({
            path: "/",
          });
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
  },
};
</script>
